import React from 'react';
import { OrderSellerLocation } from '../../../../api/shop/types/orderTypes';
import { getImageUrl } from '../../../../utils/imageUrl';
import './OrderPickupDetails.css';

interface OrderPickupDetailsProps {
  sellerLocation: OrderSellerLocation;
  expectedPickupDate: string | null;
  pickupLocation?: string;
}

const OrderPickupDetails: React.FC<OrderPickupDetailsProps> = ({ 
  sellerLocation, 
  expectedPickupDate,
  pickupLocation
}) => {
  const formatDate = (dateString: string | null) => {
    if (!dateString) return 'TBD';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-GB', { 
        day: 'numeric', 
        month: 'short', 
        year: 'numeric' 
      });
    } catch {
      return 'TBD';
    }
  };

  return (
    <div className="order-pickup-details-container">
      <h3 className="order-pickup-details-title">Order Pickup Details</h3>
      
      <div className="pickup-details-content">
        <div className="pickup-details-combined">
          <div className="pickup-detail-item">
            <img 
              src={getImageUrl('admin/static-assets/icons/general/Icon-calender.svg')} 
              alt="Calendar" 
              className="pickup-detail-icon"
            />
            <div className="pickup-detail-info">
              <span className="pickup-items-label">Expected Pickup date</span>
              <span className="pickup-items-value">{formatDate(expectedPickupDate)}</span>
            </div>
          </div>
          
          <div className="pickup-detail-item">
            <img 
              src={getImageUrl('admin/static-assets/icons/general/icon-Location.svg')} 
              alt="Location" 
              className="pickup-detail-icon"
            />
            <div className="pickup-detail-info">
              <span className="pickup-items-label">Pickup Location</span>
              <span className="pickup-items-value pickup-location">
                {pickupLocation || sellerLocation.name || 'Not specified'}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderPickupDetails;